import { Link } from '@tanstack/react-router';

import type { CheckoutQuote } from '../api/endpoints/planPayment';
import { orderSummary } from '../lib/planPayment';

/**
 * /pago's order: the plan and cycle being paid, how the total is made, and the
 * one figure charged today. The annual saving is the only colored word.
 */
export function PagoSummary({ quote, canChangePlan }: { quote: CheckoutQuote; canChangePlan: boolean }) {
  const summary = orderSummary(quote);
  const annual = quote.billingCycle === 'annual';
  return (
    <section className="pago-summary" aria-labelledby="pago-summary-label">
      <h2 className="section-label" id="pago-summary-label">
        Resumen
      </h2>
      <div className="pago-summary-slab">
      <div className="pago-summary-plan">
        <p className="pago-summary-title">{summary.title}</p>
        <p className="pago-summary-cycle">{summary.cycle}</p>
      </div>
      <dl className="pago-summary-rows">
        {summary.rows.map((row) => (
          <div key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>
      <div className="pago-summary-total">
        <p>Total hoy</p>
        <p className="pago-summary-figure">{summary.total}</p>
      </div>
      <p className="pago-summary-note" data-tone={annual ? 'good' : undefined}>
        {summary.note}
      </p>
      {canChangePlan ? (
        <p className="pago-summary-change">
          <Link to="/membresia">Cambiar plan</Link>
        </p>
      ) : null}
      </div>
    </section>
  );
}
